import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// 英文翻译
import enCommon from "./locales/en/common.json";
import enSidebar from "./locales/en/sidebar.json";
import enPages from "./locales/en/pages.json";
import enSettings from "./locales/en/settings.json";
import enWorkspace from "./locales/en/workspace.json";
import enBilling from "./locales/en/billing.json";
import enAdmin from "./locales/en/admin.json";
import enKnowledge from "./locales/en/knowledge.json";

// 中文翻译
import zhCommon from "./locales/zh/common.json";
import zhSidebar from "./locales/zh/sidebar.json";
import zhPages from "./locales/zh/pages.json";
import zhSettings from "./locales/zh/settings.json";
import zhWorkspace from "./locales/zh/workspace.json";
import zhBilling from "./locales/zh/billing.json";
import zhAdmin from "./locales/zh/admin.json";
import zhKnowledge from "./locales/zh/knowledge.json";

const resources = {
  en: {
    common: enCommon,
    sidebar: enSidebar,
    pages: enPages,
    settings: enSettings,
    workspace: enWorkspace,
    billing: enBilling,
    admin: enAdmin,
    knowledge: enKnowledge,
  },
  zh: {
    common: zhCommon,
    sidebar: zhSidebar,
    pages: zhPages,
    settings: zhSettings,
    workspace: zhWorkspace,
    billing: zhBilling,
    admin: zhAdmin,
    knowledge: zhKnowledge,
  },
} as const;

i18n
  .use(LanguageDetector) // 检测用户浏览器语言
  .use(initReactI18next) // 传递 i18n 实例给 react-i18next
  .init({
    resources,
    fallbackLng: "en", // 默认语言设为英文
    debug: false,

    // 语言检测选项
    detection: {
      order: ["localStorage", "navigator"], // 优先从 localStorage 读取手动选择的语言，然后检测浏览器语言
      lookupLocalStorage: "workus-language", // localStorage 键名
      caches: ["localStorage"], // 缓存到 localStorage
    },

    // 命名空间设置
    defaultNS: "common",
    ns: ["common", "sidebar", "pages", "settings", "workspace", "billing", "admin", "knowledge"],

    interpolation: {
      escapeValue: false, // React 已经保护了 XSS
    },

    // 返回对象而不是字符串
    returnObjects: false,
  });

export default i18n;
